document.addEventListener('DOMContentLoaded', () => {
    
    function deactivateCard(container) {
        container.classList.remove('mobile-active');
        const video = container.querySelector('video');
        
        if (video && !video.classList.contains('always-playing-video')) {
            video.pause();
            video.currentTime = 0;
        }
    }

    function setupMediaHover(container) {
        const video = container.querySelector('video');
        const images = container.querySelectorAll('.media > img');
        const hasSecondImage = images.length >= 2;

        if (!video && !hasSecondImage) return;

        container.addEventListener('click', (e) => {
            const isMobile = window.matchMedia('(max-width: 990px)').matches;
            
            if (isMobile) {
                const isActive = container.classList.contains('mobile-active');

                if (!isActive) {
                    e.preventDefault(); 
                    e.stopPropagation(); 

                    document.querySelectorAll('.card--media.mobile-active').forEach(deactivateCard);

                    container.classList.add('mobile-active');

                    if (video) {
                        video.muted = true;
                        video.playsInline = true;
                        video.play().catch(err => console.log('Video play error:', err));
                    }
                } 
            }
        });

        container.addEventListener('mouseenter', () => {
            if (video && !video.classList.contains('always-playing-video')) {
                video.play().catch(() => {});
            }
        });

        container.addEventListener('mouseleave', () => {
            deactivateCard(container);
        });
    }

    document.querySelectorAll('.card--media').forEach(setupMediaHover);

    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;
                if (node.classList.contains('card--media')) {
                    setupMediaHover(node);
                } else {
                    node.querySelectorAll?.('.card--media').forEach(setupMediaHover);
                }
            });
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
});

window.addEventListener('pageshow', (event) => {
    document.querySelectorAll('.card--media.mobile-active').forEach(container => {
        container.classList.remove('mobile-active');
        const video = container.querySelector('video');
        
        if (video && !video.classList.contains('always-playing-video')) {
            video.pause();
            video.currentTime = 0;
        }
    });
});